@if (dialogData$ | async; as data) {
  <div class="uig-terms-conditions-dialog"
    [cxFocus]="focusConfig"
    (esc)="close('Escape clicked', redirectToLogin)">
    <div class="cx-dialog-content">
      @if (loading$ | async) {
        <div>
          <cx-spinner></cx-spinner>
        </div>
      } @else {
        <div class="cx-dialog-header">
          <h3>{{ 'uigLegal.tcDialog.title' | cxTranslate }}</h3>
          <button
            type="button"
            class="close"
            attr.aria-label="{{ 'addToCart.closeModal' | cxTranslate }}"
            (click)="dismissModal('Cross click')"
            >
            <span aria-hidden="true">
              <cx-icon [type]="iconTypes.CLOSE"></cx-icon>
            </span>
          </button>
        </div>
        <!-- Separator -->
        <div class="cx-dialog-description">
          <p [innerHTML]="'uigLegal.tcDialog.legalContent' | cxTranslate"></p>
          <div class="cx-dialog-separator col-sm-12 d-xs-block d-sm-block d-md-none"></div>
        </div>
        <!-- Actions -->
        @if (!hideButtons && !(accepted$ | async)) {
          <div class="cx-dialog-buttons">
            <a tabindex="1" class="btn btn-secondary col-sm-3" (click)="termsAndConditionsAccept()">
              {{ 'uigLegal.accept' | cxTranslate }}
            </a>
            <a tabindex="2" class="btn btn-secondary col-sm-3" (click)="termsAndConditionsDecline()">
              {{ 'uigLegal.decline' | cxTranslate }}
            </a>
          </div>
        }
      }
    </div>
  </div>
}
